import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-slate-800 mt-24">
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-wrap items-center justify-between gap-4 text-sm text-slate-400">
        <div>
          © {new Date().getFullYear()} DraftLion. Not affiliated with Sleeper, the NFL, Anthropic, or OpenAI.
        </div>
        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-white">Privacy</Link>
          <Link to="/terms" className="hover:text-white">Terms</Link>
          <a href="mailto:support@thedraftlion.com" className="hover:text-white">Contact</a>
        </div>
      </div>
    </footer>
  );
}
